// extracted by mini-css-extract-plugin
module.exports = {"goods":"_15749","cover":"_11056","info":"_12381","name":"_9561","grow":"_6339","price":"_9084","current":"_3187","prefix":"_11670","unit":"_16661","value":"_9703","cost":"_9300"};